import React, { useState, useMemo, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import ClientConferenceTickets from './ClientConferenceTickets';
import OtherConferencePasses from './OtherConferencePasses';

const ConferenceTicketDetails = () => {
  const navigate = useNavigate();
  const { memberType, eventId, ticketType } = useParams();
  const [isFormLoading, setIsFormLoading] = useState(false);

  const type = useMemo(() => ticketType || 'client-conference-tickets', [ticketType]);

  const tabOptions = [
    { label: 'Client Conference Tickets', value: 'client-conference-tickets' },
    { label: 'Other Conference Passes', value: 'other-conference-passes' },
  ];

  const handleRedirect = useCallback(
    (type) => navigate(`/${memberType}/instant-ticket-generate/${eventId}/${type}`),
    [navigate, memberType, eventId]
  );

  const activeClass = 'p-2 bg-new-car color-white text-16-500 br-5';
  const inActiveClass = 'p-2 color-black-olive text-16-500 pointer br-5';

  return (
    <div id="event-details-container">
      <Card className="d-flex align-items-center unset-br cpe-12 cps-12 pt-2 pb-2">
        <div className="w-100 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            {tabOptions.map((tab) => (
              <div
                key={tab.value}
                className={type === tab.value ? activeClass : inActiveClass}
                onClick={() => type !== tab.value && handleRedirect(tab.value)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>
      </Card>

      {isFormLoading ? (
        <Card className="cmt-24 cmb-24 cps-30 cpe-30 cpt-40 cpb-40 d-flex align-items-center justify-content-center">
          <Loader size="md" />
        </Card>
      ) : (
        <>
          {type === 'client-conference-tickets' && <ClientConferenceTickets />}
          {type === 'other-conference-passes' && <OtherConferencePasses />}
        </>
      )}
    </div>
  );
};

export default ConferenceTicketDetails;
